import NL from '../content/json/nl_NL.js';
import EN from '../content/json/en_GB.js';
import { DelierState, Locale } from "../store/store";
import ContentService from '@/services/ContentService';
import GameLogic from '@/services/GameLogic';

interface StringMap {
    [name: string]: string;
}

export default class LocaleService {

    public static hasValue(state: DelierState, tag: string): boolean {
        const map: StringMap = <StringMap>(state.locale == Locale.nl ? NL : EN);
        let result = map[tag];
        return (undefined !== result);
    }

    public static getValue(state: DelierState, tag: string): string {
        //return '((' + tag + '))';

        const map: StringMap = <StringMap>(state.locale == Locale.nl ? NL : EN);
        let result = map[tag];
        if (undefined == result) {
            return '{' + tag + '}';
        }
        result = result.replace(/\*\*([^\*]*)\*\*/g, "<b>$1</b>");
        result = result.replace(/\*([^\*]*)\*/g, "<i>$1</i>");
        result = result.replace(/\n/g, "<br>\n");
        return result;
    }

    public static getRaw(state: DelierState, key: string): string {
        const map: StringMap = <StringMap>(state.locale == Locale.nl ? NL : EN);
        if (undefined == map[key]) {
            return '{' + key + '}';
        }
        return map[key];
    }

    public static hotspotDisplayName(state: DelierState, hotspotName: string): string {
        const mobileButtonMap = <StringMap> ContentService.mobileButtonKeys;
        let key: string = hotspotName;
        if (undefined != mobileButtonMap[hotspotName]) {
            key = ['algemeen.mobielecomputer.optie.', mobileButtonMap[hotspotName], '.title'].join('');
        }
        else {
            key = ['algemeen.buttons.', hotspotName, '.label'].join('');
        }
        return this.getValue(state, key);
    }

    // resultaat pagina binnen de computer voor sommige items
    public static hotspotMobileResult(state: DelierState, hotspotName: string): string {
        const mobileButtonMap = <StringMap> ContentService.mobileButtonKeys;
        let mobileKey: string = mobileButtonMap[hotspotName]; // "contactarts"

        console.log(hotspotName, '-->', mobileKey);

        if (undefined != mobileKey) {

            const situationObject = GameLogic.getSituationObject(state);
            const situationKey: string = situationObject.situation.name; // "delier3"
            const key: string = [situationKey, '.mobielecomputer.content.', mobileKey].join(''); // "delier0.mobielecomputer.content.contactarts"

            if( this.hasValue(state, key) ) {
                return this.getValue(state, key);
            }
        }
        return '';
    }

    public static dayMessage(state:DelierState, key:string):string {
        return this.getValue(state, ['dag', state.day, '.', key].join(''));
    }

    public static situationMessage(state:DelierState, key:string):string {
        const situationObject = GameLogic.getSituationObject(state);
        return this.getValue(state, [situationObject.situation.name, '.', key].join(''));
    }

    public static optionDisplayName(state: DelierState, hotspotName: string, optionName: string): string {
        return this.getValue(state, ['acties.actie.', hotspotName, '.', optionName, '.title'].join(''));
    }

    public static optionFeedbackInactief(state: DelierState, hotspotName: string, optionName: string): string {
        return this.getValue(state, ['acties.actie.' , hotspotName , '.' , optionName , '.feedback.inactief'].join(''));
        //return this.getValue(state, ['acties.actie.' , hotspotName , '.' , optionName , '.feedback.actief'].join(''));
        //return this.getValue(state, ['acties.actie.' , hotspotName , '.' , optionName , '.feedback.genegeerd'].join(''));
    }

    public static tipKey(hotspotName: string, optionName: string): string {
        return ['acties.actie.' , hotspotName , '.' , optionName , '.tip'].join('');
    }
}